import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { useGlobal } from "reactn";

import { Section } from "@jsluna/section";

import {
  trackEvent,
  SubmitButton,
  Notification,
} from "@jsainsburyplc/id-ui-common";

import { categoryTypes, actionTypes } from "constants/tracking";
import { getMultiMissionCompleteLink } from "utils/urls";

import PageFormat from "components/PageFormat";
import MyIdConfirmation from "components/MyIdConfirmation";
import MultiMissionLogo from "components/MultiMissionLogo";

export const ERROR_MESSAGE = "Something went wrong. Please try again";

const trackButtonClick = (passwordConflict, readable_mission_name) => {
  trackEvent({
    category: passwordConflict
      ? categoryTypes.MY_ID_CONFIRMATION_DIFF_PW
      : categoryTypes.MY_ID_CONFIRMATION_SAME_PW,
    action: actionTypes.CLICK,
    label: `Continue to ${readable_mission_name}`,
  });
};

const MyIdConfirmationPage = ({ passwordConflict }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [submitFailed, setSubmitFailed] = useState(false);
  const formRef = useRef(null);
  const [readable_mission_name] = useGlobal("readable_mission_name");

  const handleSubmit = (e) => {
    setIsLoading(true);
    trackButtonClick(passwordConflict, readable_mission_name);
    try {
      formRef.current.submit();
    } catch (err) {
      setIsLoading(false);
      setSubmitFailed(true);
    }
  };

  return (
    <PageFormat>
      <Section
        className="c-hero c-hero--center"
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
        }}
      >
        <MultiMissionLogo />
      </Section>

      <MyIdConfirmation passwordConflict={passwordConflict} />

      {submitFailed && (
        <div className="ln-u-margin-top*2">
          <Notification>{ERROR_MESSAGE}</Notification>
        </div>
      )}
      <form
        ref={formRef}
        action={getMultiMissionCompleteLink()}
        onSubmit={handleSubmit}
        method="post"
        className="ln-u-text-align-center ln-u-margin-top*4"
      >
        <SubmitButton
          submitHandler={handleSubmit}
          fullWidth={true}
          isLoading={isLoading}
          isLoadingLabel="Loading"
          label={`Continue to ${readable_mission_name}`}
        />
      </form>
    </PageFormat>
  );
};

MyIdConfirmationPage.defaultProps = {
  passwordConflict: false,
};

MyIdConfirmationPage.propTypes = {
  passwordConflict: PropTypes.bool,
};

export default MyIdConfirmationPage;
